import { Typography } from 'antd';
import AvmPrivateListingsTab from '../avm/AvmPrivateListingsTab';

const { Title, Text } = Typography;

export default function ParticularsPage() {
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Listado Particulares</Title>
        <Text type="secondary">
          Anunciantes particulares (sin agencia) obtenidos de Idealista vía Apify.
          Introduce un Run ID y pulsa Sincronizar para actualizar el listado.
        </Text>
      </div>
      <AvmPrivateListingsTab />
    </div>
  );
}
